<template lang="html">
  <div class="legal-page">
    <div class="entry-content">

      <div v-if="language == 'de'">
        <h1>Impressum</h1>
        <div class="textmedia__inner">
          <p>Bildnachweis Startseite "Coworking": Leeza Soho by Zaha Hadid Architects. Render by MIR.</p>
          <p class="singlecolumntext">Die Volkswagen AG ist eine Aktiengesellschaft deutschen Rechts mit Hauptsitz in Wolfsburg.<br>
            <b style=""><br>
              Vorstand:<br>
            </b>Herbert Diess (Vorsitzender)<br>
            Oliver Blume<br>
            Gunnar Kilian<br>
            Andreas Renschler<br>
            Abraham Schot<br>
            Stefan Sommer<br>
            Hiltrud D. Werner<br>
            Frank Witter<br>
            <br>
            <b>Postanschrift:</b> Berliner Ring 2, 38440 Wolfsburg<br>
            <b>Tel.:</b> +49-5361-9-0<br>
            <b style="">Fax:</b> +49-5361-9-28282<br>
            <b style="">E-Mail:</b> <a href="mailto:vw@volkswagen.de">vw@volkswagen.de</a><br>
            <br>
            Die Volkswagen Aktiengesellschaft ist im Handelsregister des Amtsgericht Braunschweig unter der&nbsp;<span style="">Nr. HRB 100484 eingetragen.</span></p>

            <p class="singlecolumntext">Die Umsatzsteueridentifikationsnummer der Volkswagen AG ist DE 115235681.</p>

            <p class="singlecolumntext">Volkswagen ist zur Teilnahme an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle weder bereit noch dazu verpflichtet.</p>



          </div>
        </div>

        <div class="" v-else>
          <h1>Imprint</h1>
          <div class="textmedia__inner">
            <p>Photo Credit Front Page "Coworking": Leeza Soho by Zaha Hadid Architects. Render by MIR.</p>
            <p class="singlecolumntext">Volkswagen Aktiengesellschaft is a publicly quoted stock corporation under German law, with its registered office in Wolfsburg.<br>
              <br>
              <b>Board of Management:<br>
              </b>Herbert Diess (Chairman)<br>
              Oliver Blume<br>
              Gunnar Kilian<br>
              Andreas Renschler<br>
              Abraham Schot<br>
              Stefan Sommer<br>
              Hiltrud D. Werner<br>
              Frank Witter<br>
              <br>
              <b>Postal address:</b> Berliner Ring 2, 38440 Wolfsburg, Germany<br>
              <b style="">Tel.:</b> +49-5361-9-0<br>
              <b style="">Fax:</b> +49-5361-9-28282<br>
              <b style="">e-mail:</b> <a href="mailto:vw@volkswagen.de">vw@volkswagen.de</a><br>
              <br>
              Volkswagen Aktiengesellschaft is entered in the Register of Companies at the District Court of Braunschweig under number HRB 100484.</p>

              <p class="singlecolumntext">The sales tax (VAT) registration number of Volkswagen AG is DE 115235681.</p>

              <p class="singlecolumntext">Volkswagen is neither committed nor obliged to participate in dispute resolution before a consumer arbitration board.</p>

            </div>
          </div>

        </div>
      </div>
    </template>

    <script>
    import { mapGetters } from 'vuex'

    export default {
      computed: {
        ...mapGetters(['language'])
      },
      mounted(){
        $('.logo_svg').removeClass("light");
        $('.header .back').removeClass("hidden");
      }
    }
    </script>

    <style lang="scss">
    .legal-page{
      margin: 0 auto;
      width: 80%;
      padding-top: 200px;
      padding-bottom: 200px;
      p,a,span,h1,h2,h3,strong{
        font-family:  'Union Regular',Helvetica, Arial, sans-serif;;
        font-weight:  normal;
        font-style:   normal;
        font-stretch: normal;
      }
      h1{
        margin-bottom: 2rem;
      }
      p{
        margin-bottom: 2rem;
      }
      ul{
            list-style-type: disc;
            padding-inline-start: 40px;
            margin-bottom: 2rem;

      }
      hr{
        margin: 10px 0;
      }
    }
    </style>
